import BlobImage from '@atoms/BlobImage/BlobImage';
import RichText from '@atoms/RichText/RichText';
import Tags from '@atoms/Tags/Tags';
import Time from '@atoms/Time/Time';
import { metaType } from '@lib/proptypes';
import vacancyDetailsType from '@lib/proptypes/vacancyDetails';
import ApplyCta from '@molecules/ApplyCta/ApplyCta';
import Meta from '@molecules/Meta/Meta';
import VacancyDetails from '@molecules/VacancyDetails/VacancyDetails';
import BottomWave from '@svg/detail-hero-bottom-wave-mobile.svg';
import InfoCirleIcon from '@svg/info-circle.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './DetailHero.module.scss';
import ShareButton from './ShareButton';

function DetailHero({
  title,
  text,
  image,
  imageAlt,
  date,
  dateFormat,
  tags,
  meta,
  highlightedMessage,
  paddingBottom,
  modifier,
  vacancyDetails,
  ctaBlock,
  subtitle,
  applicationFormRef,
  formInView,
}) {
  return (
    <section
      className={classNames(
        styles.container,
        styles[modifier],
        paddingBottom && styles.paddingBottom
      )}
    >
      <div className={styles.content}>
        {!!tags && <Tags tags={tags} extraClasses={styles.tags} />}
        <h1 className={styles.title}>{title}</h1>
        {!!subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {!!date && !subtitle && (
          <Time
            date={date}
            format={dateFormat}
            extraClasses={styles.subtitle}
          />
        )}
        {!!text && <RichText text={text} />}
        {!!meta && <Meta meta={meta} extraClasses={styles.meta} />}
        {!!vacancyDetails && <VacancyDetails details={vacancyDetails} />}
        {!!ctaBlock && (
          <div className={styles.ctaBlock}>
            <ApplyCta
              applicationFormRef={applicationFormRef}
              vacancy={title}
              formInView={formInView}
              vacancyDetails={vacancyDetails}
            />
            <ShareButton title={title} text={text} />
          </div>
        )}
        {!!highlightedMessage && (
          <div className={styles.highLightedMessage}>
            <InfoCirleIcon />
            {highlightedMessage}
          </div>
        )}
      </div>
      <div className={styles.imageContainer}>
        {image && (
          <BlobImage
            image={image}
            alt={imageAlt}
            sizes="(min-width: 1024px) 100vw, (min-width: 1280px) 624px, (min-width: 1536px) 651px"
            showImageAsBlobFromLg
            noBorder
          />
        )}
        <BottomWave className={styles.bottomWave} />
      </div>
    </section>
  );
}

DetailHero.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
    placeholder: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  imageAlt: PropTypes.string,
  date: PropTypes.string,
  subtitle: PropTypes.string,
  dateFormat: PropTypes.string,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.string,
    })
  ),
  meta: metaType,
  highlightedMessage: PropTypes.string,
  paddingBottom: PropTypes.bool,
  modifier: PropTypes.string,
  vacancyDetails: vacancyDetailsType,
  ctaBlock: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  applicationFormRef: PropTypes.any,
  formInView: PropTypes.bool,
};

export default DetailHero;
